import { Post } from "./common";

export default class BlobService {
  static getClientToken = async (token: string, data: any) =>
    await Post({ path: "blob/", token, body: data });
}
